module.exports = __webpack_public_path__ + "img/02_BandonBluff.b39679dd.jpg";